export enum OrderActionType {
  Refund = 0,
  Recharge = 1,
  ManualPayment = 2
}
